import { getApiBaseUrl, socketHandler } from "app/shared/utils";
import { sharedLib } from "@shared/services/shared.service";
import storageService from "utils/localStorageService";
import allEndpoints from "@shared/services/endpoints";
import { buildBaseQuery } from "@shared/services/baseQuery";
import { commonSlice } from "@shared/slices/common.slice";
import { createAuthSlice } from "@shared/slices/auth.slice";

const baseUrl = getApiBaseUrl();
sharedLib.init(
  storageService,
  baseUrl,
  socketHandler,
  undefined,
  allEndpoints,
  buildBaseQuery,
  commonSlice,
  createAuthSlice
);
